import React, { useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import "./css/Newheader.css";
import { useDispatch } from "react-redux";
import { logout } from "../../auth/authSlice";
import QuizFaqs from "./QuizFaqs";

const Newheader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isStartQuizPage = /^\/quiz-dashboard\/startQuiz\/\d+$/.test(
    location.pathname,
  );
  const logOut = () => {
    dispatch(logout());
    navigate("/home");
  };
  return (
    <nav className="dashboard-navbar">
      <div className="dashboard-nav-container">
        {/* Logo */}
        <div className="dashboard-nav-brand">
          {/* Logo doubles as the back-to-dashboard link (Go Back button removed). */}
          {!isStartQuizPage && (
            <Link to="/" className="dashboard-brand-link">
              <img
                src="../images/docmasterLogo.png"
                alt="DocMaster Quiz Logo"
                className="dashboard-brand-logo"
              />
            </Link>
          )}
        </div>
        <button
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
        >
          ☰
        </button>
        {/* Navigation Menu */}
        <ul
          className={`dashboard-nav-menu ${
            isMobileMenuOpen ? "mobile-menu-open" : ""
          }`}
          role="menubar"
          aria-label="Main"
        >
          <li>
            <NavLink
              to="/QuizHomePage"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Home
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/quiz-dashboard"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Dashboard
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/aboutQuiz"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              About Quiz
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/quiz-syllabus"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Syllabus
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/participate"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              How to Participate
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/testimonials"
              className={({ isActive }) =>
                `dashboard-nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Testimonials
            </NavLink>
          </li>
        </ul>

        {/* Action Buttons */}
        <div className="dashboard-nav-actions">
          <button
            className="dashboard-btn-getstarted"
            style={{ padding: "6px 12px", fontSize: "13px" }}
            onClick={logOut}
          >
            Log Out
          </button>
        </div>
      </div>
      {!isStartQuizPage && <QuizFaqs />}
    </nav>
  );
};

export default Newheader;
